import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import SEO from '../utils/seo'
import { colors } from '../styles/theme'

const NotFound = () => {
  return (
    <>
      <SEO title="404 - Page Not Found" />

      <div className="min-h-[600px] flex items-center justify-center">
        <div className="container-custom max-w-2xl text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            {/* Animated 404 */}
            <motion.div
              className="mb-8"
              animate={{
                y: [0, -10, 0],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut',
              }}
            >
              <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan to-purple mb-4">
                404
              </h1>
            </motion.div>

            <h2 className="text-3xl md:text-4xl font-bold text-off-white mb-4">
              Page Not Found
            </h2>

            <p className="text-lg text-gray-400 mb-8">
              Looks like this prompt didn't return any results. The page you're looking for doesn't
              exist or has been moved.
            </p>

            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button
                component={Link}
                to="/"
                variant="contained"
                size="large"
                startIcon={<HomeIcon />}
                sx={{
                  backgroundColor: colors.info,
                  color: colors.textOnAccent,
                  fontWeight: 600,
                  px: 4,
                  py: 1.5,
                  fontSize: '1rem',
                  '&:hover': {
                    backgroundColor: colors.infoHover,
                  },
                }}
              >
                Back to Home
              </Button>
            </motion.div>

            {/* Fun terminal-style error */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="mt-12 bg-slate/40 backdrop-blur-sm rounded-lg p-6 font-mono text-left max-w-md mx-auto border border-slate"
            >
              <div className="text-cyan text-sm">
                <span className="text-purple">&gt;_</span> GET /
                {typeof window !== 'undefined' ? window.location.pathname : ''}
              </div>
              <div className="text-gray-400 text-sm mt-2">
                <span className="text-red-400">Error:</span> 404 Not Found
              </div>
              <div className="text-gray-500 text-xs mt-2">Try navigating from the home page</div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </>
  )
}

export default NotFound
